import { OpsiumUser } from '@/modules/common/types/opsium-user';

export class InitializedRootEvent {
  type: 'INITIALIZED' = 'INITIALIZED';
  user: OpsiumUser | null;
  intendedRoute: string | null;

  constructor({ user, intendedRoute }: { user: OpsiumUser | null; intendedRoute: string | null }) {
    this.user = user;
    this.intendedRoute = intendedRoute;
  }
}

export class LoggedInRootEvent {
  type: 'LOGGED_IN' = 'LOGGED_IN';
  user: OpsiumUser;

  constructor({ user }: { user: OpsiumUser }) {
    this.user = user;
  }
}

export class NavigateToRootEvent {
  type: 'NAVIGATE_TO_ROOT' = 'NAVIGATE_TO_ROOT';

  constructor() {}
}

export class LogoutRequestedRootEvent {
  type: 'LOGOUT_REQUESTED' = 'LOGOUT_REQUESTED';

  constructor() {}
}

export class LoggedOutRootEvent {
  type: 'LOGGED_OUT' = 'LOGGED_OUT';

  constructor() {}
}

export class InitializedOnboardingEvent {
  type: 'INITIALIZED_ONBOARDING' = 'INITIALIZED_ONBOARDING';

  constructor() {}
}

export type RootEvent =
  | InitializedRootEvent
  | LoggedInRootEvent
  | LogoutRequestedRootEvent
  | NavigateToRootEvent
  | InitializedOnboardingEvent
  | LoggedOutRootEvent;
